module.exports = __webpack_public_path__ + "static/media/cambio-de-contrasena.e5b029ad.svg";